module.exports = __webpack_public_path__ + "static/img/banner_01.1f13b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/banner_01.png
// module id = ARNj
// module chunks = 0